import './CopyA.scss';

import { b2x } from '@b2x/react/src';
import React from 'react';

import { ComponentWrapper } from './ComponentWrapper';
import { DetailsAContentType } from './contentTypes';

export const DetailsA = ({ columns, header, options }: DetailsAContentType) => {
  const _headingType = header?.options?.headingType as string;

  console.log(_headingType);

  return (
    <ComponentWrapper classNames="details-a bg-primary text-white text-center" options={options}>
      {(header?.title || header?.content) && (
        <b2x.Row className="mb-5" justifyContent={'center'}>
          <b2x.Col size={{ md: 10, xl: 8, xs: 12 }}>
            {header.title && (
              <b2x.Div style={{ textWrap: 'balance' }}>
                {React.createElement(_headingType, { class: 'h1 mb-3' }, b2x.formatHtml(header.title.toUpperCase()))}
              </b2x.Div>
            )}
            {header.content && <b2x.Div className="h3 mb-0">{b2x.formatHtml(header.content)}</b2x.Div>}
          </b2x.Col>
        </b2x.Row>
      )}
      {columns && columns.length > 0 && (
        <b2x.Row className="g-md-5 g-xl-6" gap={{ xs: 3 }} justifyContent={'center'}>
          {columns.map((column) => (
            <b2x.Col key={column.contentSectionId} size={{ md: 'auto', xs: 6 }}>
              {column.value && <b2x.Div className="h1 mb-3 fw-semi-bold">{b2x.formatHtml(column.value)}</b2x.Div>}
              {column.title && (
                <b2x.Div className="h3 fw-semi-bold lh-base" marginBottom={{ md: 0, xs: 3 }}>
                  {b2x.formatHtml(column.title.toUpperCase())}
                </b2x.Div>
              )}
            </b2x.Col>
          ))}
        </b2x.Row>
      )}
    </ComponentWrapper>
  );
};
